export const Style = ({ colors = [] }) => (
  <g id="Estilo1_9_">
    <g>
      <g>
        <path
          id="SVGID_46_"
          style={{ fill: colors[0] }}
          d="M96.6,162l31.3-7.5l-8.4-35c-2.1-8.7-10.8-14-19.4-11.9l0,0 		c-8.7,2.1-14,10.8-11.9,19.4L96.6,162z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_99_"
            d="M96.6,162l31.3-7.5l-8.4-35c-2.1-8.7-10.8-14-19.4-11.9l0,0c-8.7,2.1-14,10.8-11.9,19.4L96.6,162z"
          />
        </defs>
        <clipPath id="SVGID_100_">
          <use xlinkHref="#SVGID_99_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="SVGID_101_"
          gradientUnits="userSpaceOnUse"
          x1="104.557"
          y1="331.4355"
          x2="118.5587"
          y2="331.4355"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>
        <path
          style={{
            opacity: '0.3',
            clipPath: 'url(#SVGID_100_)',
            fill: 'url(#SVGID_101_)',
            enableBackground: 'new',
            mixBlendMode: 'multiply'
          }}
          d="M110.7,134.4 		c2.2,2.9,4.2,6,5.7,9.4c1.4,3.4,2.3,7,2.1,10.7c0,0.7-0.1,1.4-0.3,2.1c-0.5,2-1.8,3.7-3.5,4.8c-1.7,1.1-3.9,1.4-5.9,1 		c-0.8-0.2-1.5-0.4-2.2-0.9c-0.6-0.5-1-1.1-1.3-1.7c-0.6-1.2-0.9-2.5-0.8-3.8c0.2-1.4,1-2.7,1.9-3.8c0.9-1.1,2-2.1,2.9-3.1 		c2.2-2.5,3.5-6,2.5-9.1c-0.5-1.4-1.4-2.6-1.7-4.1c-0.1-0.2-0.1-0.4,0-0.6c0.1-0.2,0.3-0.4,0.5-0.3c0.1,0,0.2,0.1,0.3,0.2 		c0.5,0.6,1,1.4,1.3,2.1"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          id="SVGID_49_"
          style={{ fill: colors[0] }}
          d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4 		c-2.6,1.1-1,3.9-0.2,6.6c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0 		c-1.6-10.3-1.1-27.5-0.1-42.6c13.8-4.2,4.4-21.3,2.5-27.2c1.1-9.7,2-16.3,2-16.3C113.1,113.2,112.6,109.3,109.8,108.3z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_102_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-1.6-10.3-1.1-27.5-0.1-42.6 			c13.8-4.2,4.4-21.3,2.5-27.2c1.1-9.7,2-16.3,2-16.3C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_103_">
          <use xlinkHref="#SVGID_102_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_40_"
          gradientUnits="userSpaceOnUse"
          x1="45.2941"
          y1="304.3146"
          x2="69.1263"
          y2="304.3146"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>

        <path
          id="Multiply_19_"
          style={{
            opacity: '0.3',
            clipPath: 'url(#SVGID_103_)',
            fill: 'url(#Multiply_40_)',
            enableBackground: 'new'
          }}
          d=" 		M56.6,145.6c-3.5,8.4-1.3,18.9,5.3,25.3c0.5,0.5,1,1,1.1,1.6c0,0.6-0.3,1.1-0.7,1.6c-1,1.2-2.2,2.3-3,3.7s-1.2,3.2-0.4,4.6 		c0.9,1.6,3.1,2.3,3.5,4.1c0.5,2.5-3,4.3-2.9,6.9c0,1.9,2,3.2,3.8,4c1.9,0.9,3.7,1.8,5.5,2.7c-0.3,0.8-1.5,0.5-2.3,0.8 		c-1,0.4-1,1.9-0.3,2.7c0.7,0.8,1.8,1.1,2.9,1.3c0.3,0.6-0.7,1-1.4,1c-5.1-0.1-10.2-0.2-15.3-0.4c-1.3,0-2.7-0.1-4-0.4 		c-0.4-0.1-0.8-0.3-1.1-0.6c-0.3-0.4-0.4-0.9-0.5-1.4c-1.5-13.4-1.9-27-1.2-40.5c0.1-1.2,0.1-2.4,0.5-3.6 		c0.3-1.1,0.9-2.2,1.6-3.1c2.1-3.2,5-5.9,8.4-7.7"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_104_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-1.6-10.3-1.1-27.5-0.1-42.6 			c13.8-4.2,4.4-21.3,2.5-27.2c1.1-9.7,2-16.3,2-16.3C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_105_">
          <use xlinkHref="#SVGID_104_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_41_"
          gradientUnits="userSpaceOnUse"
          x1="48.0564"
          y1="370.7416"
          x2="74.46"
          y2="370.7416"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>

        <path
          id="Multiply_18_"
          style={{
            opacity: '0.15',
            clipPath: 'url(#SVGID_105_)',
            fill: 'url(#Multiply_41_)',
            enableBackground: 'new',
            mixBlendMode: 'multiply'
          }}
          d=" 		M74.5,116c-7.2-1.6-14.6-3.9-19.8-9.1c-1.1-1.1-3.8-4.8-5.7-4.3c-2.8,0.7,1.9,4.2,2.7,4.9c4.1,3.4,8.9,5.9,14,7.2 		C68.5,115.5,71.5,115.9,74.5,116z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_106_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-1.6-10.3-1.1-27.5-0.1-42.6 			c13.8-4.2,4.4-21.3,2.5-27.2c1.1-9.7,2-16.3,2-16.3C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_107_">
          <use xlinkHref="#SVGID_106_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="Multiply_42_"
          gradientUnits="userSpaceOnUse"
          x1="91.94"
          y1="372.86"
          x2="106.04"
          y2="372.86"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>

        <path
          id="Multiply_17_"
          style={{
            opacity: '0.15',
            clipPath: 'url(#SVGID_107_)',
            fill: 'url(#Multiply_42_)',
            enableBackground: 'new',
            mixBlendMode: 'multiply'
          }}
          d=" 		M102.9,101.5c1.1,0.4,2.2,1,3.1,1.7c-3.1,2.7-6.4,5.1-9.8,7.4c-1.3,0.8-2.8,1.9-4.3,2.2c0.2-0.9,1.7-1.6,2.4-2.2 		c1.1-0.9,2.1-1.8,3.2-2.8C99.5,105.9,101.3,103.8,102.9,101.5z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_108_"
            d="M109.8,108.3l-11.9-6c-18.6,22.3-43.1,0.5-43.1,0.5l-18.3,8.4c-2.6,1.1-1,3.9-0.2,6.6 			c0,0,11.8,30.9,13.7,70.2c0.3,5.1-0.6,12.9-0.8,14c20.7,3.1,47.9,2.2,58.6,0c-1.6-10.3-1.1-27.5-0.1-42.6 			c13.8-4.2,4.4-21.3,2.5-27.2c1.1-9.7,2-16.3,2-16.3C113.1,113.2,112.6,109.3,109.8,108.3z"
          />
        </defs>
        <clipPath id="SVGID_109_">
          <use xlinkHref="#SVGID_108_" style={{ overflow: 'visible' }} />
        </clipPath>

        <linearGradient
          id="SVGID_110_"
          gradientUnits="userSpaceOnUse"
          x1="115.9995"
          y1="319.6211"
          x2="103.8355"
          y2="321.7792"
          gradientTransform="matrix(1 0 0 -1 0 480)"
        >
          <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
          <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
          <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
          <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
          <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
        </linearGradient>
        <path
          style={{
            opacity: '0.3',
            clipPath: 'url(#SVGID_109_)',
            fill: 'url(#SVGID_110_)',
            enableBackground: 'new',
            mixBlendMode: 'multiply'
          }}
          d="M103.7,157.5 		c-0.3,0.1-0.7,0.1-0.9,0.3c-0.3,0.3-0.3,0.8-0.1,1.2s0.5,0.7,0.8,1c1.4,1.5,2.4,3.3,2.9,5.3c0.1,0.5,0.2,1,0.7,1.2 		c0.6,0.3,1.3-0.2,1.7-0.7c1.1-1.5,1.5-3.5,2.4-5.2c0.8-1.5,2-2.7,2.9-4.2c0.6-0.9,1.7-3.1,0.7-4.1c-1-0.9-2.3,0.9-3.1,1.5 		C109.4,155.8,106.6,157,103.7,157.5z"
        />
      </g>
    </g>
    <path
      style={{ fill: colors[0] }}
      d="M51.5,164l-31.3-7.5l8.4-35c2.1-8.7,10.8-14,19.4-11.9l0,0c8.7,2.1,14,10.8,11.9,19.4L51.5,164z"
    />
    <path
      style={{
        fill: 'none',
        stroke: '#000000',
        strokeWidth: '0.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10'
      }}
      d=" M110.4,133.1c12.4,24.7-2.9,26.3-2.9,26.3"
    />

    <polyline
      style={{
        fill: 'none',
        stroke: '#000000',
        strokeWidth: '0.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10'
      }}
      points=" 44.1,162.5 51.5,164 56.8,142.2 		"
    />
  </g>
)
